/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import User from "../models/userModel";
import Account from "../models/accountModel";

let beaconVisible: boolean = true;

export function setBeaconIds(user: User, account: Account | null) {
    if (user.isDemoAccount) return clearBeaconIds();
    const customerId = getCustomerID(user);
    const identity = {
        'account-id': account?.id,
        'user-id': user.id,
        'customer-id': customerId,
        'email': user.email,
        'name': user.fullName,
        'company-name': account?.selectablePlatformLabel,
        'subscription': user.subscription?.statusLabel
    };
    window.Beacon('identify', identity);
}

export function clearBeaconIds() {
    window.Beacon('identify', {
        'account-id': '',
        'user-id': '',
        'email': '',
        'name': '',
        'customer-id': '',
        'company-name': '',
        'subscription': ''
    });
}

export function hideBeacon() {
    if (!beaconVisible) return;
    window.Beacon('destroy');
    beaconVisible = false;
}

export function showBeacon() {
    if (beaconVisible) return;
    window.Beacon('init', '2ffd5ecb-63ef-4168-8b0c-c38e2042624a')
    beaconVisible = true;
}

function getCustomerID(user: User | null): string | null {
    return user?.subscription?.customerId ?? null;
}